import { Component, input, type InputSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaceNotificationPreviewInterface } from './pace-notification-preview.interface';
import { RouterLink } from '@angular/router';
import { PaceLink } from '../utils/link.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'lib-pace-notification-preview',
    standalone: true,
    imports: [CommonModule, RouterLink, FontAwesomeModule],
    templateUrl: './pace-notification-preview.component.html',
    styleUrls: ['./pace-notification-preview.component.scss'],
})
export class PaceNotificationPreviewComponent {
    public readonly notificationType = input.required<string>();
    public readonly notification = input.required<PaceNotificationPreviewInterface>();
    public readonly extraLinks: InputSignal<PaceLink[]> = input<PaceLink[]>([]);

    public onLinkClick(link: PaceLink): void {
        if (link.action) {
            link.action();
        }
    }
}
